import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { initSentry, SentryErrorBoundary } from './lib/sentry';
import { initPerformanceMonitoring } from './lib/performance';
import App from './App';
import './index.css';

// Initialize monitoring before rendering
initSentry();
initPerformanceMonitoring();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SentryErrorBoundary
      fallback={() => (
        <div className="min-h-screen bg-gallery-900 flex items-center justify-center p-4">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gallery-100 mb-4">Something went wrong</h1>
            <p className="text-gallery-400 mb-4">We've been notified and are working on it.</p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-accent-500 hover:bg-accent-600 text-white rounded-lg"
            >
              Reload Page
            </button>
          </div>
        </div>
      )}
    >
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </SentryErrorBoundary>
  </React.StrictMode>
);
